import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { getNextStep, getStepIndex, canOpenStep, stepRoute } from 'pages/Profile/helper';
import { PORTAL_ROUTES } from 'utils/constants';

const secondary = 'inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-[10px] border-[1.5px] border-secondary-200 bg-white px-3 py-2.5 text-[13px] font-semibold text-secondary-600 transition-colors hover:border-secondary-300 hover:bg-secondary-50 sm:flex-none sm:px-5 sm:py-[11px] sm:text-sm';

const Footer = ({ stepId }) => {
  const { completion }: any = useOutletContext() || {};
  const navigate = useNavigate();

  const next = getNextStep(stepId);
  const canOpenNext = next && canOpenStep(getStepIndex(next.id), completion);

  return (
    <div className="flex flex-shrink-0 items-center justify-end gap-2 border-t border-gray-100 bg-white px-4 py-3 sm:gap-2.5 sm:px-5 sm:py-3.5 lg:px-10">
      <button type="button" onClick={() => navigate(PORTAL_ROUTES.PROFILE)} className={secondary}>
        <ArrowLeft size={15} strokeWidth={2.5} />
        All forms
      </button>

      {canOpenNext && (
        <button type="button" onClick={() => navigate(stepRoute(next))} className={secondary}>
          <span className="hidden sm:inline">Next:&nbsp;</span>{next.navLabel}
          <ArrowRight size={15} strokeWidth={2.5} />
        </button>
      )}
    </div>
  );
};

export default Footer;
